/**
 * 時間フォーマット用ユーティリティ
 */

/**
 * 時間文字列をHH:mm形式にフォーマット
 * HH:mm:ss形式の場合は秒を除去
 * @param timeString - フォーマットする時間文字列
 * @returns HH:mm形式の時間文字列
 */
export const formatTimeToHHMM = (timeString: string | undefined | null): string => {
  if (!timeString) return '';

  // HH:mm:ss または HH:mm 形式を想定
  const parts = timeString.split(':');
  if (parts.length >= 2) {
    // 最初の2つの部分（時と分）のみを取得
    return `${parts[0]}:${parts[1]}`;
  }

  return timeString;
};

/**
 * 日付文字列を日本語形式でフォーマット
 * @param dateString - フォーマットする日付文字列
 * @returns M月D日形式の日付文字列
 */
export const formatDateToJapanese = (dateString: string | undefined | null): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    return `${date.getMonth() + 1}月${date.getDate()}日`;
  } catch {
    return '';
  }
};
